import BankApplication from './BankApplication';

export default BankApplication;
